import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const serviceSupportPathMap = localizePathMap({
	[Locale.cs]: "servis-a-podpora",
	[Locale.en]: "service-and-support",
});
